import {
  GET_SURVEY,
  UPDATE_SECTIONS,
  CLEAR_SURVEY_V2,
  SET_SURVEY_HISTORY_DIFF,
  IS_FETCHED_HISTORY,
  SET_HIGHLIGHT_STEP,
  SurveyV2State,
  SurveyActionTypes,
} from '../types';

const INITIAL_STATE: SurveyV2State = {
  survey: null,
  sections: [],
  surveyHistoryDiff: undefined,
  isFetchedHistory: false,
  highlightStepArray: undefined,
};

export default (state = INITIAL_STATE, action: SurveyActionTypes): SurveyV2State => {
  switch (action.type) {
    case CLEAR_SURVEY_V2:
      return {
        ...state,
        survey: null,
        sections: [],
      };
    case GET_SURVEY:
      return {
        ...state,
        survey: action.payload,
      };
    case UPDATE_SECTIONS: {
      return {
        ...state,
        sections: action.payload,
      };
    }
    case IS_FETCHED_HISTORY: {
      return {
        ...state,
        isFetchedHistory: action.payload,
      };
    }
    case SET_SURVEY_HISTORY_DIFF: {
      return {
        ...state,
        surveyHistoryDiff: action.payload,
      };
    }
    case SET_HIGHLIGHT_STEP: {
      return {
        ...state,
        highlightStepArray: action.payload,
      };
    }
    default:
      return state;
  }
};
